// apps/client/src/assets/builders/board.ts — the plaza notice board: two posts, a wooden board with a cream header and three pinned
// notes, under a small green roof slab. Footprint 2 × 1, facing +z (south, toward the camera) at rot 0.
import * as THREE from 'three';
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';
import { toyMaterial } from '../../characters/doll';
import type { CodeBuilder } from '../service';

export const builder: CodeBuilder = {
  id: 'board',
  build() {
    const g = new THREE.Group();
    const part = (geo: THREE.BufferGeometry, hex: string, x: number, y: number, z: number, rz = 0) => {
      const m = new THREE.Mesh(geo, toyMaterial(hex));
      m.position.set(x, y, z);
      m.rotation.z = rz;
      m.castShadow = m.receiveShadow = true;
      g.add(m);
      return m;
    };
    const post = new RoundedBoxGeometry(0.14, 1.3, 0.14, 3, 0.04);
    part(post, '#8A6A4F', -0.7, 0.65, 0);
    part(post, '#8A6A4F', 0.7, 0.65, 0);
    part(new RoundedBoxGeometry(1.7, 0.95, 0.1, 3, 0.04), '#B08A63', 0, 0.87, 0.09);
    part(new RoundedBoxGeometry(1.5, 0.16, 0.03, 2, 0.012), '#FFF4E2', 0, 1.22, 0.15);
    const note = new RoundedBoxGeometry(0.36, 0.42, 0.012, 2, 0.005);
    [[-0.52, 0.06], [0, -0.05], [0.52, 0.04]].forEach(([x, rz]) => part(note, '#FFFBF1', x!, 0.82, 0.146, rz!));
    part(new RoundedBoxGeometry(1.95, 0.08, 0.42, 3, 0.03), '#5DAE62', 0, 1.39, 0.08);
    return g;
  },
};
